import { render, staticRenderFns } from "./NuevoMovimiento.vue?vue&type=template&id=2ae4221a&scoped=true&"
import script from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
export * from "./NuevoMovimiento.vue?vue&type=script&lang=js&"
import style0 from "./NuevoMovimiento.vue?vue&type=style&index=0&id=2ae4221a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae4221a",
  null
  
)

export default component.exports